/* eslint-disable max-classes-per-file */
import Module from '@/scripts/old/classes/Module';

import { clearInputFile } from '@/scripts/old/helpers/utils';

const NAMESPACE = 'data-photo-attach';

class PhotoAttach {
  constructor(params) {
    const {
      el,
      inputEl,
      removeEl,
      previewEl,
      removedEl,
      attachment,
    } = params;

    this.onInputChangeShim = (e) => {
      this.onInputChange(e);
    };

    this.onClickRemoveShim = (e) => {
      this.onClickRemove(e);
    };

    this.el = el;
    this.inputEl = inputEl;
    this.removeEl = removeEl;
    this.removedEl = removedEl;
    this.previewEl = previewEl;

    if (attachment) {
      this.el.classList.add('_attached');

      if (this.previewEl && !this.previewEl.getAttribute('src')) {
        this.previewEl.setAttribute('src', attachment);
      }
    }

    this.isActive = this.el.classList.contains('_active');
    this.setEvents();
  }

  setEvents(add = true) {
    const action = add ? 'addEventListener' : 'removeEventListener';
    this.inputEl[action]('change', this.onInputChangeShim);
    if (this.removeEl) {
      this.removeEl[action]('click', this.onClickRemoveShim);
    }
  }

  destroy() {
    this.setEvents(false);
  }

  clear() {
    clearInputFile(this.inputEl);
    this.onInputChange();
  }

  onInputChange() {
    const file = this.inputEl.files && this.inputEl.files[0];

    this.el.classList[file ? 'add' : 'remove']('_attached');

    if (this.previewEl) {
      if (file) {
        const reader = new window.FileReader();
        reader.onload = (e) => {
          this.previewEl.setAttribute('src', e.target.result);
        };
        reader.readAsDataURL(file);
      } else {
        this.previewEl.setAttribute('src', '');
      }
    }

    if (this.removedEl) {
      this.removedEl.value = file ? 'Y' : '';
    }
  }

  onClickRemove(e) {
    e.preventDefault();
    this.clear();
  }
}

class PhotoAttachModule extends Module {
  constructor() {
    super(`[${NAMESPACE}]`);
  }

  initInstance(el) {
    const inputEl = el.querySelector(`[${NAMESPACE}-input]`);
    const removeEl = el.querySelector(`[${NAMESPACE}-remove]`);
    const previewEl = el.querySelector(`[${NAMESPACE}-preview]`);
    const removedEl = el.querySelector(`[${NAMESPACE}-removed]`);
    const attachment = el.getAttribute(NAMESPACE);

    if (!inputEl) return;

    const photoAttach = new PhotoAttach({
      el,
      inputEl,
      removeEl,
      previewEl,
      removedEl,
      attachment,
    });

    this.instances.set(el, photoAttach);
  }

  destroyInstance(instance) {
    instance.destroy();
  }
}

export default new PhotoAttachModule();
